import { Component, Input, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { isPlatformServer } from '@angular/common';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-confirmation',
  imports: [],
  templateUrl: './confirmation.html',
  // No styleUrl - all styles are inline in HTML head for email compatibility
})
export class Confirmation implements OnInit {
  @Input() userEmail: string = '';
  @Input() userName: string = '';
  @Input() signupDate: string = new Date().toLocaleDateString();
  @Input() surveyId: string = '';
  frontendUrl = environment.frontendUrl;
  surveyUrl = '';
  unsubscribeUrl = '';
  isLoaded = false;
  logoUrl = '';

  constructor(
    private route: ActivatedRoute,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnInit() {
    // Get route parameters (not query parameters)
    this.route.params.subscribe((params) => {
      if (params['userEmail']) {
        this.userEmail = params['userEmail'];
        this.unsubscribeUrl = `${this.frontendUrl}/unsubscribe/${this.surveyId}`;
      }
      if (params['surveyId']) {
        this.surveyId = params['surveyId'];
        this.surveyUrl = `${this.frontendUrl}/survey/${this.surveyId}`;
      }

      // Mark as loaded only when both URLs are populated
      if (this.userEmail && this.surveyId) {
        this.isLoaded = true;
      }
    });

    // For SSR, check if params are already available synchronously
    if (isPlatformServer(this.platformId)) {
      const params = this.route.snapshot.params;
      if (params['userEmail'] && params['surveyId']) {
        this.userEmail = params['userEmail'];
        this.surveyId = params['surveyId'];
        this.unsubscribeUrl = `${this.frontendUrl}/unsubscribe/${this.surveyId}`;
        this.surveyUrl = `${this.frontendUrl}/survey/${this.surveyId}`;
        this.isLoaded = true;
      }
    }

    // Absolute URL for email clients; path matches angular.json (src/assets → /assets)
    const base = environment.assetsBaseUrl.replace(/\/$/, '');
    this.logoUrl = `${base}/assets/logo-transparent.png`;
  }
}
